import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const CLUBS_REQUEST = 'FETCH_CLUBS_REQUEST';
export const CLUBS_FAILURE = 'FETCH_CLUBS_FAILURE';
export const CLUBS_SUCCESS = 'FETCH_CLUBS_SUCCESS';

export const fetchClubs = () => {
    return function(dispatch) {
        dispatch(fetchClubsRequest());
        return axios(apiRequestOptions(apiPath.CLUBS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchClubsSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchClubsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchClubsRequest = () => {
    return {
        type: CLUBS_REQUEST,
    }
};

const fetchClubsFailure = (error) => {
    return {
        type: CLUBS_FAILURE,
        error,
    }
};

const fetchClubsSuccess = (data) => {
    return {
        type: CLUBS_SUCCESS,
        data,
    }
};